import './Footer.scss';
import * as React from 'react';
import { connect } from 'react-redux';
import * as Core from 'components/core';
import SignOut from 'app/actionCreators/SignOut';
import { AppState } from 'app/store';
import { getSessionUser } from 'app/stateHelpers';
import figure53LogoImage from 'assets/figure-53-logo.png';
import { ExternalLink } from '@/react-ui';
type FooterLink = [string, string, boolean]; // external
type FooterColumn = {
  heading: string;
  links: Array<FooterLink>;
};
const footerLinks: Array<FooterColumn> = [
  {
    heading: 'QLab',
    links: [
      ['Download', '/download/', false],
      ['Overview', '/overview/', false],
      ['Buy', '/shop/', false],
    ],
  },
  {
    heading: 'Resources',
    links: [
      ['FAQ', '/faq/', false],
      ['Licensing QLab', '/licensing-terms/', false],
      ['Educational Pricing', '/educational-pricing/', false],
      ['Bulk Pricing', '/site-license-pricing/', false],
      ['Documentation', `/docs/v${ENV.QLAB_CURRENT_MAJOR_VERSION}/`, false],
      ['Support', '/support/', false],
      ['QLab Cookbook', '/cookbook/', false],
      ['Terms of Use', '/terms/', false],
      ['Privacy Policy', '/privacy-policy/', false],
    ],
  },
  {
    heading: 'Products',
    links: [
      ['QLab', '/', false],
      ['QLab Remote', '/qlab-remote/', false],
      ['Go Button', 'https://gobutton.app', true],
    ],
  },
  {
    heading: 'Contact',
    links: [
      ['Support', '/support/', false],
      ['Mailing List', '/mailing-list/', false],
      ['About Us', 'https://figure53.com', true],
    ],
  },

  // Dynamic account links are handled in-component
];
type Props = {
  signedIn: boolean;
};
function mapAppStateToProps(appState: AppState): Props {
  return {
    signedIn: getSessionUser(appState) !== null,
  };
}
class Footer extends React.Component<Props> {
  render() {
    const { signedIn } = this.props;
    return (
      <Core.ContentWrapper>
        <footer className="Footer">
          <div className="Footer-content">
            <nav className="Footer-content-nav">
              {footerLinks.map((footerColumn) => (
                <section
                  key={footerColumn.heading}
                  className="Footer-content-nav-section"
                >
                  <h3 className="Footer-content-nav-section-heading">
                    {footerColumn.heading}
                  </h3>
                  <ul className="Footer-content-nav-section-list">
                    {footerColumn.links.map((link) => (
                      <li
                        key={link[1]}
                        className="Footer-content-nav-section-list-item"
                      >
                        {link[2] ? (
                          <ExternalLink href={link[1]}>{link[0]}</ExternalLink>
                        ) : (
                          <Core.Link to={link[1]}>{link[0]}</Core.Link>
                        )}
                      </li>
                    ))}
                  </ul>
                </section>
              ))}

              <section className="Footer-content-nav-section">
                <h3 className="Footer-content-nav-section-heading">Account</h3>
                <ul className="Footer-content-nav-section-list">
                  <li className="Footer-content-nav-section-list-item">
                    <Core.Link to="/account/#orders">Orders</Core.Link>
                  </li>
                  <li className="Footer-content-nav-section-list-item">
                    <Core.Link to="/account/#licenses">Licenses</Core.Link>
                  </li>
                  <li className="Footer-content-nav-section-list-sign-out-link">
                    {signedIn ? (
                      <Core.Button onClick={SignOut} textLink undecorated>
                        Sign Out
                      </Core.Button>
                    ) : (
                      <Core.Link to="/account">Sign in</Core.Link>
                    )}
                  </li>
                </ul>
              </section>
            </nav>
            <nav className="Footer-companyLinks Footer-content-nav">
              <Core.Link
                external
                to="http://figure53.com/"
                className="Footer-madeByFigure53"
              >
                <span className="Footer-madeByFigure53-text">Made by</span>
                <img
                  className="Footer-madeByFigure53-image"
                  alt="Made by Figure 53"
                  src={figure53LogoImage}
                />
              </Core.Link>
              <ul className="Footer-content-nav-section-list">
                <li className="Footer-content-nav-section-list-item">
                  <Core.Link external to="https://www.instagram.com/figure53/">
                    Instagram
                  </Core.Link>
                </li>
                <li className="Footer-content-nav-section-list-item">
                  <Core.Link
                    external
                    to="https://www.youtube.com/channel/UCzEPGrt1B4WPlRyLicuS6zg"
                  >
                    YouTube
                  </Core.Link>
                </li>
              </ul>
            </nav>
          </div>
          <div className="Footer-footnote">
            Made with &#9829; in Baltimore. &#169; {new Date().getFullYear()}{' '}
            Figure 53, LLC. All Rights Reserved.
          </div>
        </footer>
      </Core.ContentWrapper>
    );
  }
}
export default connect(mapAppStateToProps)(Footer);
